document.addEventListener("DOMContentLoaded", function () {
  const qtyInput = document.querySelector('input[name="quantity"]');
  const nudge = document.getElementById("bundle-nudge");

  if (!qtyInput || !nudge) return;

  function updateNudge() {
    const qty = parseInt(qtyInput.value) || 1;

    let message = "";

  if (qty === 1) {
  message = "👉 Add 1 more item — save 5% instantly";
} else if (qty === 2) {
  message = "🔥 Add 1 more item — save 10% instantly";
} else if (qty === 3) {
  message = "🔥 Add 1 more item — save 15% instantly";
} else if (qty === 4) {
  message = "🔥 Add 1 more item & unlock 20% instantly";
} else {
  message = "🎉 You’re getting the max 20% off!";
}

    nudge.innerText = message;
  }

  qtyInput.addEventListener("change", updateNudge);
  qtyInput.addEventListener("input", updateNudge);

  updateNudge();
});